export default {
    en: {
        ERROR: "Error",
        LOADING_MESSAGE: "Loading...",
        TABBED_PANE_TABLIST_LABEL: 'Sections',
        FORM_INSTRUCTION: '* indicates a required field',
        INFO_BUTTON_LABEL: 'More Information',
    }
};
